import { useContext } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { queries } from '@/helpers/api';
import { checkURLforTree } from '@/helpers/workWithTreeFolders';
import FolderPage from '@/components/SeoBlocks/FolderPage/FolderPage';
import TemplatePage from '@/components/SeoBlocks/TemplatePage/TemplatePage';
import RegisterBanner from '@/components/blocks/RegisterBanner';
import {
  createTreeFolders,
  collectAllLvlsWithPath,
} from '@/helpers/workWithTreeFolders';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import { MainContext } from '@/context/MainContext';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const headersParse = await getHeadersFromServer(req);
  let templateData = {};
  let content = '';
  const mainData = await queries.getMainData(params.locale.toLowerCase());
  const pageData = await queries.getSeoData(params.locale.toLowerCase(), 'seo');
  const { folders, templates } = await queries.getSharedTemplates();
  const treeFolders = await createTreeFolders(folders, templates, true);
  const searchResult = await checkURLforTree(treeFolders, params.folders);

  if (searchResult.notFound) return { notFound: true };

  const { templates: allTemplatesList, folders: allFoldersList } =
    collectAllLvlsWithPath(treeFolders);

  const breadCrumbsLinks = allFoldersList
    .filter((element) => params.folders.includes(element.translatedName))
    .map((element) => ({ name: element.name, path: element.path }));

  if (
    searchResult.children === undefined &&
    searchResult.templates === undefined
  ) {
    const template = await queries.getSeoTemplateByID(searchResult.id);
    const { sides } = await queries.getSeoTemplateSides(searchResult.id);
    const previews = await queries.getSeoTemplatePreviews(searchResult.id);

    if (template.showHTML) {
      content = await queries.getSeoTemplateContent(searchResult.id);
    }

    const penultimateoneString = params.folders[params.folders.length - 2];
    const templatesFiltred = allTemplatesList.filter(
      (elem) =>
        elem.translatedName !== searchResult.translatedName &&
        elem.folder.translatedName === penultimateoneString
    );
    templateData = { template, sides, previews, templatesFiltred, content };
  }

  return {
    props: {
      initialState: {
        main: mainData,
      },
      seoMain: pageData,
      searchResult,
      templateData,
      breadCrumbsLinks,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const ContentPage = ({
  searchResult,
  seoMain,
  templateData,
  breadCrumbsLinks,
}) => {
  const { main } = useContext(MainContext);

  if (searchResult.templates)
    return (
      <>
        <FolderPage
          templates={searchResult.templates}
          folder={searchResult}
          seoMain={seoMain}
          breadCrumbsLinks={breadCrumbsLinks}
          {...searchResult}
        />
      </>
    );
  return (
    <>
      <TemplatePage
        breadCrumbsLinks={breadCrumbsLinks}
        seoMain={seoMain}
        solutions={main?.solutions}
        {...searchResult}
        {...templateData}
      />
      <RegisterBanner />
    </>
  );
};

export default ContentPage;
